import { usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

import { useDmsWithLegislativeBodiesConnection } from '../../../decisionMakers/hooks/useDmsWithLegislativeBodiesConnection';

type Result = ModelHookResult<{
	showLegislativeBodies: boolean;
	showDMSection: boolean;
}>;

export function useDecisionMakerSection(): Result {
	const {
		data: { isUserEligibleForLegislativeBodies },
	} = usePetitionDetailsPageUserData();

	const {
		data: { totalCount: dmsAndLBsTotalCount },
	} = useDmsWithLegislativeBodiesConnection();

	return {
		data: {
			showLegislativeBodies: isUserEligibleForLegislativeBodies,
			showDMSection: dmsAndLBsTotalCount > 0,
		},
	};
}
